import { IntegrationDTO, SystemTemplateApiError, SystemTemplateModel } from "../models/system-template.models";
import { ClearViewUtils } from "../utils";
import { CvApiServiceBase } from "./cv-api-service-base";

export class SystemTemplateServiceBase {
    SystemTemplateApiError = SystemTemplateApiError; // allow JS to access enum

    systemTemplateInfo = {
        name: "",
        group: "",
        dashboardKey: "",
    };

    constructor(
        fromSharedService: boolean = false,
        private cvApiService?: CvApiServiceBase,
    ) {
        if (fromSharedService)
            return SystemTemplateServiceBase.getServiceBase();

        if (!cvApiService)
            this.cvApiService = CvApiServiceBase.getServiceBase();
    }

    static getServiceBase(): SystemTemplateServiceBase {
        return ClearViewUtils.getSharedService(SystemTemplateServiceBase, 'SystemTemplateServiceBase');
    }

    async loadIntegrationList() {
        try {
            const response = await this.cvApiService.get<IntegrationDTO[]>('/api/v2/systemtemplate/loadintegrationlist/');
            if (response.status_code === 200)
                return response;
            else
                throw response;
        } catch (err) {
            throw err;
        }
    }

    async saveNewCxOneSystemTemplate(systemTemplateModel: SystemTemplateModel) {
        const response = await this.cvApiService.post<SystemTemplateModel>(
            "/api/v2/systemtemplate/savecxonesystemtemplate",
            systemTemplateModel
        );

        if (response.status_code === 201)
            return response.data;
        else
            throw response;
    }

    async updateCxOneSystemTemplate(systemTemplateModel: SystemTemplateModel) {
        const response = await this.cvApiService.post<SystemTemplateModel>(
            "/api/v2/systemtemplate/updatecxonesystemtemplate",
            systemTemplateModel
        );

        if (response.status_code === 200)
            return response;
        else
            throw response;
    }

    async saveNewSystemTemplate(dashboardKey: string, systemTemplateModel: SystemTemplateModel) {
        if (!dashboardKey)
            throw new Error("Missing required dashboardKey");

        const response = await this.cvApiService.post<SystemTemplateApiError>(
            `/api/v2/systemtemplate/savenewsystemtemplate/${dashboardKey}`,
            systemTemplateModel
        );

        if (response.status_code === 201)
            return response.data;
        else
            throw response;
    }

    async hasSystemTemplateAdminAccess() {
        const response = await this.cvApiService.get<boolean>('/api/v2/systemtemplate/hassystemtemplateadminaccess/');
        if (response.status_code === 200)
            return response.data;
        else
            throw response;
    }

    async removeSystemTemplate(systemTemplateKey: string) {
        if (!systemTemplateKey)
            return;

        const response = await this.cvApiService.delete<void>(`/api/v2/systemtemplate/deletesystemtemplate/${systemTemplateKey}`);
        if (response.status_code === 200)
            return response;
        else
            throw response;
    }
}
